var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRampLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 320H96L11.572 488.857C6.256 499.49 13.988 512 25.875 512H358.125C370.014 512 377.746 499.49 372.43 488.857L288 320ZM352 0H32C14.25 0 0 14.25 0 32V352C0 368.5 12.625 381.5 28.625 383.25L63 314.5C63.25 313.875 63.75 313.5 64 313V64H320V313C320.25 313.5 320.75 314 321 314.5L355.375 383.25C371.375 381.5 384 368.375 384 352V32C384 14.25 369.75 0 352 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRampLoading);
export default __webpack_public_path__ + "static/media/ramp-loading.9189e95e55ea62d0b5ce44f3659b2f56.svg";
export { ForwardRef as ReactComponent };